import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AbilityEffect,
  AttachedTable,
} from "@dndModels";
import { FeatureSource, ModelBase } from "@models";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import AbilityEffectInput from "@dndComponents/feature/AbilityEffectInput";
import AddButton from "@components/input/buttons/icon_buttons/AddButton";

interface Props { 
  effects: AbilityEffect[];
  onChange: (changed: AbilityEffect[]) => void;
  disabled: boolean;
  for_obj?: ModelBase;
  feature_source?: FeatureSource;
  attached_table?: AttachedTable;
}

export default function EffectsInput({ 
  effects,
  onChange,
  disabled,
  for_obj,
  feature_source,
  attached_table
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [show_effect, setShowEffect] = useState("");
  // const [special_refresh_rule, setSpecialRefreshRule] = useState(false);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  // console.log(myObj);
  // console.log(obj);
  // const refresh_rule_helper = REFRESH_RULES.includes(obj.special_resource_refresh_rule) ? obj.special_resource_refresh_rule : "Special";
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className='header padded'
        size={{
          xs: 12
        }}>
        Effects&nbsp;
        { !disabled &&
          <AddButton
            onClick={ () => {
              // debugger;
              const effect = new AbilityEffect();
              effects.push(effect);
              onChange(effects);
              setShowEffect(effect.true_id);
              setReloading(true);
            }}
          />
        }
      </Grid>
      { !reloading && effects.map(effect => {
        let name = effect.type === "Damage" ? effect.damage_types.join(", ") : effect.type;
        if (effect.name !== "") {
          name += " " + effect.name;
        }
        if (!["None","Self Condition"].includes(effect.type) && effect.attack_type !== "None") {
          name += ` ${effect.attack_type}`;
        }
        return (
          <Grid
            key={effect.true_id}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 12
              }}>
              <ToggleButtonBox
                name={ name }
                value={ show_effect === effect.true_id }
                // disabled={disabled}
                onToggle={ () => { 
                  setShowEffect(show_effect === effect.true_id ? "" : effect.true_id);
                }}
              />
            </Grid>
            { show_effect === effect.true_id && 
              <AbilityEffectInput 
                obj={effect}
                disabled={disabled}
                feature_source={feature_source}
                for_obj={for_obj}
                attached_table={attached_table}
                onChange={() => {
                  onChange(effects);
                }}
                onDelete={() => {
                  onChange(effects.filter(o => o.true_id !== effect.true_id));
                }}
              />
            }
          </Grid>
        );
      })}
    </Grid>
  );
}
